import React from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";

interface BreadcrumbItems {
  label: string;
  path: string;
  active?: boolean;
}

interface PageTitleProps {
  breadCrumbItems: Array<BreadcrumbItems>;
  title: string;
  // Optional line rendered directly under the title, in the same flex item
  // as the heading - so it sits close to it (title-subtitle feel) instead of
  // a separate block spaced out by `.page-title-box`'s own padding.
  subtitle?: string;
}

/**
 * PageTitle
 */
const PageTitle = (props: PageTitleProps) => {
  return (
    <Row>
      <Col>
        <div className="page-title-box">
          <div>
            <h4 className="page-title">{props.title}</h4>
            {props.subtitle && <p className="text-muted mb-0">{props.subtitle}</p>}
          </div>
          <div className="page-title-right">
            <Breadcrumb listProps={{ className: "m-0" }}>
              <Breadcrumb.Item href="/">Dashboard</Breadcrumb.Item>

              {(props.breadCrumbItems || []).map((item, index) => {
                return item.active ? (
                  <Breadcrumb.Item active key={index}>
                    {item.label}
                  </Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item key={index} href={item.path}>
                    {item.label}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PageTitle;
